<template>
  <div>
      <DashboardBorrowers v-if="action === 'DashboardBorrowers'"></DashboardBorrowers>
      <DashboardLoanAmountBorrowers v-if="action === 'DashboardLoanAmountBorrowers'"></DashboardLoanAmountBorrowers>
      <DashboardOutstandingRemainBorrowers v-if="action === 'DashboardOutstandingRemainBorrowers'"></DashboardOutstandingRemainBorrowers>
      <DashboardProsecutionBorrowers v-if="action === 'DashboardProsecutionBorrowers'"></DashboardProsecutionBorrowers>
      <DashboardLoanSpendingBorrowers v-if="action === 'DashboardLoanSpendingBorrowers'"></DashboardLoanSpendingBorrowers>
      <DashboardPaymentDueBorrowers v-if="action === 'DashboardPaymentDueBorrowers'"></DashboardPaymentDueBorrowers>
     <DashboardStageAgingNormalBorrowers v-if="action === 'DashboardStageAgingNormalBorrowers'"></DashboardStageAgingNormalBorrowers>
      <DashboardStageAgingAllBorrowers v-if="action === 'DashboardStageAgingAllBorrowers'"></DashboardStageAgingAllBorrowers>
      <DashboardStageAging1Borrowers v-if="action === 'DashboardStageAging1Borrowers'"></DashboardStageAging1Borrowers>
      <DashboardStageAging2Borrowers v-if="action === 'DashboardStageAging2Borrowers'"></DashboardStageAging2Borrowers>
      <DashboardStageAging3Borrowers v-if="action === 'DashboardStageAging3Borrowers'"></DashboardStageAging3Borrowers>
      <DashboardFollowUpBorrowers v-if="action === 'DashboardFollowUpBorrowers'"></DashboardFollowUpBorrowers>
  </div>
</template>

<script>
import DashboardBorrowers from "@/views/pages/Dashboard/List/Components/DashboardBorrowers/index.vue";
import DashboardLoanAmountBorrowers
  from "@/views/pages/Dashboard/List/Components/DashboardLoanAmountBorrowers/index.vue";
import DashboardOutstandingRemainBorrowers from "@/views/pages/Dashboard/List/Components/DashboardOutstandingRemainBorrowers/index.vue";
import DashboardProsecutionBorrowers
  from "@/views/pages/Dashboard/List/Components/DashboardProsecutionBorrowers/index.vue";
import DashboardLoanSpendingBorrowers
  from "@/views/pages/Dashboard/List/Components/DashboardLoanSpendingBorrowers/index.vue";
import DashboardPaymentDueBorrowers
  from "@/views/pages/Dashboard/List/Components/DashboardPaymentDueBorrowers/index.vue";
import DashboardStageAgingNormalBorrowers
  from "@/views/pages/Dashboard/List/Components/DashboardStageAgingNormalBorrowers/index.vue";
import DashboardStageAgingAllBorrowers
  from "@/views/pages/Dashboard/List/Components/DashboardStageAgingAllBorrowers/index.vue";
import DashboardStageAging1Borrowers
  from "@/views/pages/Dashboard/List/Components/DashboardStageAging1Borrowers/index.vue";
import DashboardStageAging2Borrowers
  from "@/views/pages/Dashboard/List/Components/DashboardStageAging2Borrowers/index.vue";
import DashboardStageAging3Borrowers
  from "@/views/pages/Dashboard/List/Components/DashboardStageAging3Borrowers/index.vue";
import DashboardFollowUpBorrowers from "@/views/pages/Dashboard/List/Components/DashboardFollowUpBorrowers/index.vue";

export default {
  components: {
    DashboardBorrowers,
    DashboardLoanAmountBorrowers,
    DashboardOutstandingRemainBorrowers,
    DashboardProsecutionBorrowers,
    DashboardLoanSpendingBorrowers,
    DashboardPaymentDueBorrowers,
    DashboardStageAgingNormalBorrowers,
    DashboardStageAgingAllBorrowers,
    DashboardStageAging1Borrowers,
    DashboardStageAging2Borrowers,
    DashboardStageAging3Borrowers,
    DashboardFollowUpBorrowers
  },
  computed: {
    action () {
      return this.$route.params.action
    },
  },
}
</script>

<style scoped>
</style>
